import styled from "styled-components"
import { 
    // COLOR,
    // FONT
 } from 'assets'
 
export const GenreUploadContainerStyled = styled.div`
/*===============================================
 Container 
===============================================*/
    
/*===============================================
Theme 
===============================================*/
  
`